import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { toast } from 'sonner';

export default function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      setShowBanner(false);
      toast.success('Back online! Syncing data...', {
        duration: 3000,
        icon: <Wifi className="w-4 h-4" />
      });
    };

    const handleOffline = () => {
      setIsOffline(true);
      setShowBanner(true);
      toast.warning('You are offline. You can still access previously viewed content, bookmarks, and Zap Tools.', {
        duration: 5000,
        icon: <WifiOff className="w-4 h-4" />
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial status
    if (!navigator.onLine) {
      setShowBanner(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white py-2 px-4 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <WifiOff className="w-5 h-5" />
          <span className="text-sm font-medium">
            You're offline - Previously viewed content, bookmarks, and Zap Tools are available
          </span>
        </div>
        <button
          onClick={() => setShowBanner(false)}
          className="text-white hover:text-amber-100 text-lg font-bold"
        >
          ×
        </button>
      </div>
    </div>
  );
}
